<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body
          p 新增藥物
            span.icon-right(@click="$emit('closeForm')") X
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 藥碼*
              input.form-control(v-model="code")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 學名*
              input.form-control(v-model="genericName")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 料位號*
              input.form-control(v-model="CGMHNumber")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 藥盒條碼
              input.form-control(v-model="packageCode2")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 產品名
              input.form-control(v-model="productName")
          div.form-group
            div.form-row
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 單包裝含量*
                input.form-control(v-model="packContent")
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 管制等級*
                input.form-control(v-model="restrainedClass")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 衛生署字號
              input.form-control(v-model="licenseId")
          div.form-group
            div.input-group
              div.input-group-prepend
                span.input-group-text 製造廠商
              input.form-control(v-model="manufacturer")
          hr
          button.btn.btn-secondary.float-right(
            :disabled="formComplete === false"
            @click="addDrug"
          ) 新增
</template>

<script>
export default {
  name: 'CreateMedicineForm',
  data() {
    return {
      code: null,
      genericName: null,
      productName: '',
      packageCode1: '',
      packageCode2: '',
      CGMHNumber: null,
      restrainedClass: 0,
      packContent: 0,
      licenseId: undefined,
      manufacturer: undefined,
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    formComplete() {
      if (this.generic_name === null) return false;
      if (this.code === null) return false;
      if (this.CGMHNumber === null) return false;
      return true;
    },
  },
  methods: {
    checkMedWithSameCGMHNumber(CGMHNumber) {
      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: CGMHNumber,
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          return true;
        }
        return false;
      });
    },
    addDrug() {
      const newDrug = {
        // type: null,
        code: this.code,
        CGMH_number: this.CGMHNumber,
        // package_code: null,
        package_code2: this.packageCode2,
        generic_name: this.genericName,
        product_name: this.productName,
        // chinese_name: '',
        // content_amount: null,
        // content_unit: '',
        // content_amount_divider: null,
        // content_unit_divider: '',
        // content_percent: null,
        // dosage_unit: '',
        // dose_unit: '',
        // total_content_amount: null,
        // total_content_unit: '',
        pack_content: this.packContent,
        restrained_class: this.restrainedClass,
        license_id: this.licenseId,
        manufacturer: this.manufacturer,
        // return_stock: null,
        // return_when_empty: null,
        // rx_check: null,
        // inventory_type: null,
        // drug_picture_1: null,
        // drug_picture_2: null,
        // drug_box_picture: null,
        // group: [],
      };
      this.instance.get('/api/medication/', {
        params: {
          has_code: this.code,
        },
      })
      .then((res) => {
        if (res.data.results.length === 0) {
          this.instance.get('/api/medication/', {
            params: {
              has_CGMH_number: this.CGMHNumber,
            },
          })
          .then((res) => {
            if (res.data.results.length === 0) {
              this.instance.post('/api/medication/', newDrug)
                .then(() => {
                  this.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '新增成功',
                  });
                  this.$emit('closeForm');
                  this.$parent.$refs.vuetable.refresh();
                })
                .catch((err) => {
                  this.$store.commit('SET_MESSAGE', {
                    type: 'error',
                    context: err.response.data,
                  });
                });
            } else {
              this.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '料位號重複，請重新確認',
              });
            }
          });
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'warn',
            context: '藥碼重複，請重新確認',
          });
        }
      });
    },
  },
  watch: {
    restrainedClass(val) {
      if (isNaN(val)) {
        this.restrainedClass = 0;
      } else {
        this.restrainedClass = parseInt(val, 10);
      }
    },
    packContent(val) {
      if (isNaN(val)) {
        this.packContent = 0;
      } else {
        this.packContent = parseInt(val, 10);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// CreateMedicineForm.vue?d28165dc